import {useEffect, useState} from "react";
import {getCookie, setCookie} from "./index";
import Action from "../../components/action";
import classNames from "classnames";
import {textAlignment} from "../../utils/block-utils";
import ModalDialog from "../../components/modal-dialog";

export default function Design1({
                                    modalId,
                                    title,
                                    message,
                                    cookie = false,
                                    cookieDays = 30,
                                    onClose,
                                    canClose = true,
                                    actions,
                                    ...props
                                }) {
    const [isOpen, setIsOpen] = useState(false);
    const id = modalId;

    useEffect(() => {
        if (cookie) {
            const seen = getCookie(`popUp_${id}`);
            if (!seen) {
                setIsOpen(true);
                setCookie(`popUp_${id}`, "true", cookieDays);
            }
        } else {
            setIsOpen(true);
        }
    }, [id, cookie, cookieDays]);

    const handleClose = () => {
        setIsOpen(false);
        onClose?.();
    };

    return (
        <ModalDialog
            isOpen={isOpen}
            onClose={handleClose}
            canClose={canClose}
            className="popup-design-1"
            frameClassName="!items-start !pt-[calc(var(--site-nav-height)+64px)]"
            title={title && <span dangerouslySetInnerHTML={{__html: title}}/>}
            titleClassName="!text-xl"
        >
            <div
                className={classNames("rich-text", textAlignment(props))}
                data-body=""
                dangerouslySetInnerHTML={{__html: message}}
            />
            {actions &&
                <div className="sm:space-x-2 space-y-2 sm:space-y-0 mt-6 text-center">
                    {actions.map((action, i) => (
                        <Action
                            key={i}
                            className={"sm:w-auto w-full justify-center"}
                            {...action}
                            title={null}
                        />
                    ))}
                </div>
            }
        </ModalDialog>
    );
}
